import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/stats/categories",
    name: ROUTE_NAME.STATS_CATEGORIES,
    component: () => import("@/modules/stats/views/ViewStatCategories.vue"),
  },
];
